export default __webpack_public_path__ + "static/media/elevadoreslinga.77694e55.png";